import { useAppContext } from 'src/contexts/AppContext';
import { Marketplace, Processor } from 'src/WebApiController';

export const useMarketplaceHandledByProcessor = (
  marketplace?: Marketplace | null,
  processor?: Processor | null,
  officeId?: number | null
) => {
  const { loginContext } = useAppContext();

  const account = loginContext?.user?.activeAccount;
  const settings =
    officeId != null
      ? account?.officeMarketplaceSettings?.filter(
          (mk) => mk.officeId === officeId
        )
      : account?.marketplaceSettings;

  const isMarketplaceHandledByProcessor =
    marketplace &&
    settings?.some(
      (mk) =>
        mk.isSyncHandledByProcessor &&
        mk.mkp === marketplace &&
        (processor == null || mk.processor === processor)
    );

  return isMarketplaceHandledByProcessor;
};

export const useAnyMarketplaceHandledByProcessor = () => {
  const { loginContext } = useAppContext();

  const isMarketplaceHandledByProcessor =
    loginContext?.user?.activeAccount?.marketplaceSettings?.some(
      (mk) => mk.isSyncHandledByProcessor
    );

  return isMarketplaceHandledByProcessor;
};
